import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createCircularesProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "circulares",
        label: "Circulares",
        subLabel: "Noticias y comunicados",
        action: ctx.navigateModule("circulares"),
        search: (): ISearchResult[] => ([])
    };
};